import { JobJson } from 'bullmq';
import React from 'react';

import ShowProgress from './show-progress';

import { nodeTaskApi } from '~/client/services';

interface Props {}

const RunTask: React.FC<Props> = () => {
  const [startTask, result] = nodeTaskApi.useStartMutation();
  const [output, setOutput] = React.useState<JobJson>();

  const data = result.data;
  const jobId = data?.jobId;

  return (
    <div>
      <button
        onClick={() => {
          setOutput(undefined);
          startTask({
            jobName: 'sample',
            some: 'additional-data',
          });
        }}
      >
        Start Node Task
      </button>
      <p />
      {!!data && (
        <>
          <div>Task Result</div>
          <pre>{JSON.stringify(data, null, 2)}</pre>
          <p />
        </>
      )}
      <p />
      {!!jobId && (
        <ShowProgress
          jobId={jobId}
          pollingInterval={2000}
          onComplete={setOutput}
        />
      )}
      {!!output && (
        <>
          <div>Final Result</div>
          <pre>{JSON.stringify(output, null, 2)}</pre>
        </>
      )}
    </div>
  );
};

export default RunTask;
